import React from 'react';
import { Autocomplete, AutocompleteHandle } from '../Autocomplete';
import { Logo } from '../navigation';
import type { IntlShape } from 'react-intl';

export interface SearchNavbarProps {
  intl: IntlShape;
  clearSearch: (event?: React.MouseEvent<HTMLAnchorElement>) => Promise<void>;
  autocompleteRef?: React.RefObject<AutocompleteHandle | null>;
  onAutocompleteOpen?: () => void;
  className?: string;
}

/**
 * Search navbar component - contains logo and search bar
 * Used in DesktopFilterCategories for the left side of the search page header
 */
export const SearchNavbar: React.FC<SearchNavbarProps> = ({
  intl,
  clearSearch,
  autocompleteRef,
  onAutocompleteOpen,
  className = '',
}) => {
  return (
    <div className={`flex items-center gap-3 min-w-0 flex-1 ${className}`}>
      {/* Logo */}
      <div className="flex items-center gap-2 flex-shrink-0">
        <Logo clearSearch={clearSearch} variant="horizontal" locale={intl.locale} />
        <Logo clearSearch={clearSearch} variant="compact" locale={intl.locale} />
      </div>
      {/* Searchbar */}
      <div className="min-w-0 flex-1 max-w-lg xl:max-w-3xl w-full">
        <Autocomplete
          ref={autocompleteRef}
          onOpen={onAutocompleteOpen}
          placeholder={intl.formatMessage({
            id: 'instantsearch.searchBoxLink.placeholder',
            description: 'Placeholder for the search box',
            defaultMessage: 'Search for jobs',
          })}
        />
      </div>
    </div>
  );
};
